import { Button, Card, Flex, Spin, Tree } from "antd";
import { TReportList } from "api/services/models/types";
import { WebDPrivilege } from "api/services/models/WebDUser";
import { getReportsForUser } from "api/services/ReportService";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import ReportFilter from "components/reports/ReportFilter";
import React, { useEffect, useState } from "react";
import { ReactComponent as HamburgerIcon } from "../../Icons/vuesax/menu.svg";
import { useLayoutContext } from "components/MainContainer";
import { Sheet } from "react-modal-sheet";

const Reports: React.FC = () => {
  const [treeData, setTreeData] = useState<any[]>([]);
  const [selectedReport, setSelectedReport] = useState<any>(null);
  const { accountId, webDUser } = useTDAuthentication();
  const { toggleDrawer, isSmallScreen } = useLayoutContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetchResult();
    setSelectedReport(null);
  }, [accountId, webDUser]);

  useEffect(() => {
    fetchResult();
    setSelectedReport(null);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("no-scroll", !isSmallScreen);
  }, [isSmallScreen]);

  const fetchResult = async () => {
    setIsLoading(true);
    const result: TReportList[] = await getReportsForUser(
      accountId || "",
      webDUser?.user.userId || ""
    );
    const formattedData = formatReportsToTree(result);
    setTreeData(formattedData);
    setIsLoading(false);
  };

  const formatReportsToTree = (reports: TReportList[]) => {
    const groups: { [key: string]: any } = {};

    reports.forEach(report => {
      if (!groups[report.groupName]) {
        groups[report.groupName] = {
          title: report.groupName,
          key: report.groupName,
          children: []
        };
      }
      groups[report.groupName].children.push({
        title: report.reportName,
        key: report.reportName
      });
    });
    return Object.values(groups);
  };

  const handleClick = (nodeData: any) => {
    console.log(nodeData);
    setSelectedReport(nodeData);
    setOpen(false);
  };
  return (
    <>
      {webDUser?.hasPrivilege(
        WebDPrivilege.ManageReports || WebDPrivilege.ManageReportAccess
      ) && (
        <>
          <div style={{ backgroundColor: "#fafafa" }}>
            <div
              style={{
                padding: "0px",
                width: "100%",
                backgroundColor: "#fafafa",
                marginBottom: "40px",
                textAlign: "left"
              }}>
              <div>
                {" "}
                {isSmallScreen && (
                  <Button
                    type="text"
                    icon={<HamburgerIcon />}
                    onClick={toggleDrawer}
                    className="hamburger-menu-button"
                    style={{ marginRight: ".25rem" }}
                  />
                )}
                <span style={{ fontWeight: 700, lineHeight: "31px", fontSize: "24px" }}>
                  Reports
                </span>
              </div>
            </div>
          </div>
          <div>
            {isLoading && (
              <Flex justify="space-around" style={{ width: "100%", textAlign: "center" }}>
                <Spin tip="Loading, please wait..." />
              </Flex>
            )}
            {!isLoading && (
              <div className="flex-container" style={{ marginTop: "20px" }}>
                <Card
                  style={{
                    width: "100%",
                    height: "100%",
                    marginRight: !isSmallScreen ? "1.25rem" : "0",
                    marginBottom: "1.25rem",
                    maxWidth: !isSmallScreen ? "21.0675rem" : "100%"
                  }}
                  styles={{ body: { padding: isSmallScreen ? ".87rem" : "1.75rem" } }}>
                  {!isSmallScreen ? (
                    <Tree
                      blockNode={true}
                      treeData={treeData}
                      style={{ marginTop: "14px", color: "#1868db" }}
                      switcherIcon={({ expanded }) =>
                        <span style={{ fontWeight: "bold" }}>{expanded ? "-" : "+"}</span>
                      }
                      titleRender={nodeData => {
                        const isParent = nodeData.children && nodeData.children.length > 0;
                        return (
                          <span
                            role="none"
                            onClick={e => {
                              e.stopPropagation();
                              if (!isParent) {
                                handleClick(nodeData);
                              }
                            }}
                            style={{ cursor: "pointer" }}
                            className={isParent ? "tree-title" : "tree-children"}>
                            {nodeData.title}
                          </span>
                        );
                      }}
                    />
                  ) : (
                    <>
                      <span
                        style={{
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "1rem"
                        }}
                        className="font-1212">
                        Report Type{" "}
                        <Button type="text" style={{ color: "#1868db", fontSize: ".75rem" }} onClick={() => setOpen(true)}>
                          Choose
                        </Button>
                      </span>
                      <span className="tree-children">{selectedReport?.key??""}</span>
                      <Sheet
                        isOpen={open}
                        onClose={() => setOpen(false)}
                        detent={"full-height"}>
                        <Sheet.Container>
                          <Sheet.Header />
                          <Sheet.Content style={{ padding: "1.25rem", maxHeight: "80vh", overflowY: "auto" }}>
                            <Tree
                              blockNode={true}
                              treeData={treeData}
                              style={{ marginTop: "14px", color: "#1868db" }}
                              switcherIcon={({ expanded }) =>
                                <span style={{ fontWeight: "bold" }}>{expanded ? "-" : "+"}</span>
                              }
                              titleRender={nodeData => {
                                const isParent =
                                  nodeData.children && nodeData.children.length > 0;
                                return (
                                  <span
                                    role="none"
                                    onClick={e => {
                                      e.stopPropagation();
                                      if (!isParent) {
                                        handleClick(nodeData);
                                      }
                                    }}
                                    style={{ cursor: "pointer" }}
                                    className={isParent ? "tree-title" : "tree-children"}>
                                    {nodeData.title}
                                  </span>
                                );
                              }}
                            />
                          </Sheet.Content>
                        </Sheet.Container>
                        <Sheet.Backdrop />
                      </Sheet>
                    </>
                  )}
                </Card>

                <Card
                  style={{
                    width: "100%",
                    height: "100%",
                    marginRight: !isSmallScreen ? "1.25rem" : "0"
                  }}
                  styles={{ body: { padding: "12px" } }}>
                  <span style={{ fontWeight: 700, lineHeight: "31px", fontSize: "16px" }}>
                    Generate Report
                  </span>
                  <ReportFilter selectedReport={selectedReport} />
                </Card>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Reports;
